document.addEventListener("DOMContentLoaded", () => {
  waitForElement('.js-recently-viewed-product').then((element) => {
    const $slider = $('.card-slider .product-list');
    $slider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      autoplay: false,
      arrows: true,
      prevArrow: $('.card-slider .prev_arr'),
      nextArrow: $('.card-slider .next_Arr_'),	
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1
          }
        }
      ]
    }); 
  });
    
  waitForElement('.js-recommended-products-slick-slider .need_to_Add').then((element) => {
    $('.product-recommendations-container .js-recommended-products-slick-slider .products-slider').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      autoplay: false,
      arrows: true,
      prevArrow: $('.js-recommended-products-slick-slider .prev_arr'),
      nextArrow: $('.js-recommended-products-slick-slider .next_Arr_'),	
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1
          }
        }
      ]
    });  
  }).catch((error) => {
    console.error(error);
  });

  function waitForElement(selector) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        return resolve(element);
      }

      const observer = new MutationObserver((mutations, me) => {
        const element = document.querySelector(selector);
        if (element) {
          me.disconnect();
          resolve(element);
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true
      });
    });
  }
    
})